export default "__VITE_ASSET__xHF4xcH6Oh9LkyqMogJl9w__"